import { render, staticRenderFns } from "./DialogScrollLockLoader.vue?vue&type=template&id=15eb686f"
import script from "./DialogScrollLockLoader.vue?vue&type=script&lang=js"
export * from "./DialogScrollLockLoader.vue?vue&type=script&lang=js"
import style0 from "./DialogScrollLockLoader.vue?vue&type=style&index=0&id=15eb686f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
